module.exports = __webpack_public_path__ + "static/fonts/Miller-Text.4db04cba.ttf";